import React from "react";
import { RadioButton } from "primereact/radiobutton";

export default function RadioButtonCore({
	className,
	label = "Radiobutton Label",
	checked = false,
	onChange = () => {},
	name = "radiobutton",
	id = "radiobutton",
}) {
	return (
		<div className={`flex align-items-cente ${className}`}>
			<RadioButton
				inputId={id}
				name={name}
				value={label}
				onChange={onChange}
				checked={checked}
			/>
			<label htmlFor="ingredient1" className="ml-2">
				{label}
			</label>
		</div>
	);
}
